/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useDashboardForm } from "./../hooks/use-dashboard-form";

const StyledMostSearched = styled.div`
  margin: 2em 0.4em;
  text-align: center;
  font-size: 14px;
  padding: 3em 6em;
  border-radius: 8px;

  .mostSearched_title {
    font-weight: 700;
    text-transform: uppercase;
  }
  .mostSearched_main {
    display: flex;
    justify-content: space-around;
  }
  .mostSearched_item {
    font-weight: 400;
    padding: 1em;
    .item_position {
      padding: 0.5em 0;
      margin: 0 35%;
      border-radius: 8px;
      font-weight: 500;
    }
    .item_searchs {
      padding: 0.7em 0;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
`;

const MostSearched = ({ color, searchStats }: any) => {
  return (
    <StyledMostSearched className={"mostSearched_container-" + color}>
      <p className="mostSearched_title">Términos más buscados con resultado</p>
      <div className="mostSearched_main">
        {searchStats?.hits?.slice(0, 3)?.map((item: any, index: number) => (
          <div className="mostSearched_item" key={index}>
            <p className="item_position">#{index + 1}</p>
            <p className="item_name">{item.keyword}</p>
            <p className="item_searchs">{item.count} BÚSQUEDAS</p>
          </div>
        ))}
      </div>
    </StyledMostSearched>
  );
};

export default MostSearched;
